(() => { if (window.BEAEPAGEJS === undefined) {
            window.BEAEPAGEJS = [];
          }

          if(window.beaePageSetting == undefined) {
            window.beaePageSetting = {};
          }
          
          window.beaePageSetting.pageId = "6915e77c438fcc64860d5bc2";
              window.beaePageSetting.pageTitle = "Kontakt"; 
              window.beaePageSetting.pageType = "page";

          let js_09BG3RU8 = () => { let BeaeUseHooks = {};
      try {
        let argid = 'beae-ri98w5f4section-js',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-ri98w5f4',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-ri98w5f4');
        args.el = args.els[0];
        ((t) => { var o;if((o=t.el.querySelector(".beae-grid-system"))==null||o.addEventListener("scroll",a=>{var r,l;let n=a.target;if(!n.classList.contains("beae-grid-carousel"))return;let s=Math.round((n.scrollLeft+n.querySelector(".beae-grid-carousel__snaps").offsetLeft)/(n.offsetWidth*.8))+1;(r=t.el.querySelector(".beae-grid-carousel__pagination div.active"))==null||r.classList.remove("active"),(l=t.el.querySelector('.beae-grid-carousel__pagination div[data-index="'+s+'"]'))==null||l.classList.add("active")}),t.mode.value=="live"){const a=t.el.querySelector('.beae-section-background-video[data-device="desktop"]'),n=t.el.querySelector('.beae-section-background-video[data-device="mobile"]'),s=[];window.BEAEVIDEO&&window.BEAEVIDEO.convertBackgroundSection&&(window.innerWidth>=768?a&&window.BEAEVIDEO.convertBackgroundSection(t.optionsVideo,a)&&s.push("desktop"):n&&window.BEAEVIDEO.convertBackgroundSection(t.optionsVideoMobile,n)&&s.push("mobile")),(a||n)&&window.addEventListener("resize",()=>{if(window.BEAEVIDEO&&window.BEAEVIDEO.convertBackgroundSection){if(!s.includes("desktop")&&window.innerWidth>=768&&a){const r=window.BEAEVIDEO.convertBackgroundSection(t.optionsVideo,a);r&&(a.innerHTML=r.html,s.push("desktop"))}if(!s.includes("mobile")&&window.innerWidth<768&&n){const r=window.BEAEVIDEO.convertBackgroundSection(t.optionsVideoMobile,n);r&&(n.innerHTML=r.html,s.push("mobile"))}}})}t.el.querySelectorAll(".beae-text-highlight").forEach(a=>{new IntersectionObserver((s,r)=>{s.forEach(l=>{l.isIntersecting&&(l.target.querySelectorAll("path, line").forEach(c=>{c.style.strokeDasharray=parseFloat(c.getAttribute("data-dash-ratio")*l.target.offsetWidth*2)+"px, 999999px"}),r.unobserve(l.target))})},{root:document,rootMargin:"0px 0px -40%"}).observe(a)}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-ri98w5f4: ', ex)
      };
    

      try {
        let argid = 'beae-ri98w5f4section-developer',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-ri98w5f4',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-ri98w5f4');
        args.el = args.els[0];
        ((data
) => { document.addEventListener("DOMContentLoaded", function () {
  // Tìm các span chứa email cụ thể
  const emailSpans = document.querySelectorAll("span");

  emailSpans.forEach((span) => {
    const text = span.textContent.trim();

    if (text === "support@motobicycles.com") {
      const link = document.createElement("a");
      link.href = "mailto:support@motobicycles.com";
      link.textContent = text;
      link.style.color = getComputedStyle(span).color;
      link.style.textDecoration = "underline";
      span.replaceWith(link);
    }

    if (text === "sales@motobicycles.com") {
      const link = document.createElement("a");
      link.href = "mailto:sales@motobicycles.com";
      link.textContent = text;
      link.style.color = getComputedStyle(span).color;
      link.style.textDecoration = "underline";
      span.replaceWith(link);
    }

    if (text === "info@motobicycles.com") {
      const link = document.createElement("a");
      link.href = "mailto:info@motobicycles.com";
      link.textContent = text;
      link.style.color = getComputedStyle(span).color;
      link.style.textDecoration = "underline";
      span.replaceWith(link);
    }
  });
}); })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-ri98w5f4: ', ex)
      };
    

      try {
        let argid = 'beae-wmxpm018block-text',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-wmxpm018',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-wmxpm018');
        args.el = args.els[0];
        ((P) => { var I;let H=(I=P.el)==null?void 0:I.querySelectorAll(".beae-x-text a");H==null||H.forEach(z=>{let O=z==null?void 0:z.getAttribute("href");z&&P.mode.value!=="builder"&&(O!=null&&O.includes("#"))&&z.addEventListener("click",A=>{let D=document.querySelector(O+","+(O==null?void 0:O.replace("#",".")));if(D)return D.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),A.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-wmxpm018: ', ex)
      };
    

      try {
        let argid = 'beae-y30dixwzblock-text',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-y30dixwz',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-y30dixwz');
        args.el = args.els[0];
        ((P) => { var I;let H=(I=P.el)==null?void 0:I.querySelectorAll(".beae-x-text a");H==null||H.forEach(z=>{let O=z==null?void 0:z.getAttribute("href");z&&P.mode.value!=="builder"&&(O!=null&&O.includes("#"))&&z.addEventListener("click",A=>{let D=document.querySelector(O+","+(O==null?void 0:O.replace("#",".")));if(D)return D.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),A.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-y30dixwz: ', ex)
      };
    

      try {
        let argid = 'beae-weyr6t9hblock-text',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-weyr6t9h',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-weyr6t9h');
        args.el = args.els[0];
        ((P) => { var I;let H=(I=P.el)==null?void 0:I.querySelectorAll(".beae-x-text a");H==null||H.forEach(z=>{let O=z==null?void 0:z.getAttribute("href");z&&P.mode.value!=="builder"&&(O!=null&&O.includes("#"))&&z.addEventListener("click",A=>{let D=document.querySelector(O+","+(O==null?void 0:O.replace("#",".")));if(D)return D.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),A.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-weyr6t9h: ', ex)
      };
    

      try {
        let argid = 'beae-nf7lbo0nblock-text',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-nf7lbo0n',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-nf7lbo0n');
        args.el = args.els[0];
        ((P) => { var I;let H=(I=P.el)==null?void 0:I.querySelectorAll(".beae-x-text a");H==null||H.forEach(z=>{let O=z==null?void 0:z.getAttribute("href");z&&P.mode.value!=="builder"&&(O!=null&&O.includes("#"))&&z.addEventListener("click",A=>{let D=document.querySelector(O+","+(O==null?void 0:O.replace("#",".")));if(D)return D.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),A.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-nf7lbo0n: ', ex)
      };
    }; if (window.BEAEBASE) {js_09BG3RU8()} else {window.BEAEPAGEJS.push(js_09BG3RU8)} })(); 